import React from "react";
import { useSignOut } from "react-auth-kit";
import { useNavigate } from 'react-router-dom';

const buttonStyle = {
    border:"none",
    background: "rgb(186, 128, 219)",
    color: "rgb(255, 255, 255)",
    font: "20px",
    padding:"10px 15px",
    margin:"5px",
    cursor: "pointer"
  };

const LogOut = () =>{
    const signOut = useSignOut();
    const navigate = useNavigate();

    const handleSignOut = () =>{
        signOut();
        navigate('/')
    }

    return(
        <button style={buttonStyle} onClick={handleSignOut}><h4>Log Out!</h4></button>
    )
    
}
export default LogOut;